import React from 'react';

export type BadgeTone =
  | 'neutral'
  | 'info'
  | 'success'
  | 'warning'
  | 'danger'
  | 'purple';

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  children: React.ReactNode;
  dot?: boolean;
}

const toneClass: Record<BadgeTone, string> = {
  neutral: 'status-neutral',
  info: 'status-info',
  success: 'status-success',
  warning: 'status-warning',
  danger: 'status-danger',
  purple: 'status-purple',
};

export function Badge({ tone = 'neutral', dot, className = '', children, ...rest }: BadgeProps) {
  const classes = ['status-badge', toneClass[tone], className].filter(Boolean).join(' ');
  return (
    <span className={classes} {...rest}>
      {dot && <span className="status-badge-dot" aria-hidden="true" />}
      {children}
    </span>
  );
}

export default Badge;
